export default __webpack_public_path__ + "static/media/CNo.34-4.1ffad430.jpg";